import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.ruleEngine')
  .factory('rulesAPI', RulesApi);

function RulesApi(): BringozApi {
  return {
    base: `/ruleengine/rule`,
    infiniteScroll: {
      address: `/ruleengine/rule`,
      cmd: 'GET'
    },
    actions: {
      createRule: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateRule: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteRule: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      }
    }
  }
}
